import Alpine from 'alpinejs';

Alpine.data('minicartItem', (key) => ({
  working: false,
  key: key,

  get cart() {
    return Alpine.store('cart');
  },

  get item() {
    return this.cart.items.find((item) => item.key === this.key);
  },

  remove() {
    this.working = true;

    let title = this.item.title;

    Shopify.cart.remove(this.key)
      .then((cart) => {
        this.$dispatch('toast:show', {
          type: 'success',
          message: `${title} has been removed from your cart.`,
        }, true);
      })
      .catch((error) => {
        this.$dispatch('toast:show', {
          type: 'error',
          message: `There was an error removing ${title} from your cart. Please try again.`,
        }, true);
      }).finally(() => {
        this.working = false;
      });
  },

  update(quantity) {
    this.working = true;

    let title = this.item.title;

    Shopify.cart.change(this.key, quantity)
      .catch((error) => {
        this.$dispatch('toast:show', {
          type: 'error',
          message: `There was an error updating ${title} in your cart. Please try again.`,
        }, true);
      }).finally(() => {
        this.working = false;
      });
  }
}));